import { capitalize } from '@/util/string'
import { crmRequest, request } from '@meta-vue/util'
import packageInfo from '../../package.json'
import { IM_WORKBENCH_MAP } from '@/constant'
import { menus } from '@/layout/container/const.js'

let imWorkbenchInfoPromise
const defaultCacheTime = 0 // 业务类型默认不缓存

export default {
  state: {
    siderMenus: [],
    currentMenu: null,
    title: capitalize(packageInfo.name.replace(/-(\w)/g, (_, $1) => ` ${$1.toUpperCase()}`)),
    imStatus: 3, // 客服在线状态
    imWorkBenchId: '', // 在线客服工作台id，区分企业和普通在线客服
    isBusinessIm: false, // 是否为企业客服
    recordTempId: '',
    // 查询配置下发信息
    ocsConfigList: {
      workbenchBizCacheTime: defaultCacheTime, // 要的缓存时间
      withdrawAbleLength: null // 可撤销时间 null表示可撤销时间无限，0表示不可撤销
    },
    powers: {},
    jumpSwitchConfig: {}
  },
  getters: {
    imStatus: state => state.imStatus,
    ImWorkBenchId: state => state.imWorkBenchId || '1001',
    isBusinessIm: state => state.isBusinessIm || false,
    recordTempId: state => state.recordTempId,
    isSpecialOnlineReception: state => state.imWorkBenchId !== IM_WORKBENCH_MAP.ONLINE_IM, // 是否为特殊在线接待场景：在线接待中 workbenchId 不为 平台客服的场景 （现有企业客服，零担客服两种）
    isImPage: (state, getters, rootState) => {
      return _.get(rootState, 'route.path', '').includes('/im/') || _.get(window, 'location.hash', '').includes('#/im')
    },
    // 客服配置
    ocsConfig: state => state.ocsConfigList,
    jumpSwitchConfig: state => state.jumpSwitchConfig
  },
  actions: {
    $$onRouteChange({ commit, state }, { to }) {
      const menu = findCurrentMenu(state.siderMenus, to)
      console.log(menu, 'ssssjdwoiefjiowefjoi')
      if (state.currentMenu !== menu) {
        commit('SET_CURRENT_MENU', menu)
      }
    },
    setImStatus({ commit }, data) {
      commit('SET_IM_STATUS', data)
    },
    /**
     * 获取在线客服所在工作台信息
     * 热线im场景指定workbenchId=1001
     * yapi - https://yapi.amh-group.com/#/project/167/interface/api/111356
     */
    async getImWorkbenchInfo({ commit, state, getters }) {
      if (state.imWorkBenchId || imWorkbenchInfoPromise) return
      try {
        //注意这个判断会使这个请求只会调用一次，下次尽量imWorkbenchInfoPromise已经是有值，所以不会再请求
        let response = {
          channelCode: '',
          recordTempId: ''
        }
        response = await crmRequest('/qmove-crm-admin/customerService/online/workbench/queryBasicInfo', {
          method: 'post',
          silent: true,
          data: {}
        })

        console.log(response, 'responseresponseresponse')
        commit('SET_IM_WORKBENCH_INFO', response)
        if (response.accountAvatar) {
          commit('SET_OCS_CONFIG', {
            serviceAvatar: response.accountAvatar
          })
        }
        imWorkbenchInfoPromise = response
      } catch (e) {
        imWorkbenchInfoPromise = null
        commit('SET_IM_WORKBENCH_INFO', {})
      }
    },
    /**
     * 获取在工作台全局配置信息
     * yapi - http://qa-boss.amh-group.com/yapi/#/project/167/interface/api/147133
     */
    async getWbCacheTime({ commit, state }, data) {
      let config = {}
      try {
        const csConfig = await crmRequest('/crm-online-service-app/onlineCustomerService/setting/getOcsConfigList', {
          method: 'get',
          silent: true,
          params: {
            workbenchId: data?.workbenchId || state.imWorkBenchId,
            businessLine: data?.businessLine
          }
        })
        config = csConfig || {}
        if (!csConfig.bizTypeCacheSeconds) config.bizTypeCacheSeconds = defaultCacheTime
        commit('SET_OCS_CONFIG', config)
      } catch (e) {
        commit('SET_WB_CACHE_TIME', defaultCacheTime)
      }
      try {
        const grayConfig = await crmRequest('/crm-customer-service-app/gray/queryGrayInfo', {
          method: 'post',
          silent: true,
          data: {
            scene: 'queryCsFiles'
          }
        })
        commit('SET_OCS_CONFIG', {
          ...config,
          disabledDownloadImg: grayConfig?.hit === false
        })
      } catch (e) {
        console.error(e)
      }
    }
  },
  mutations: {
    RESET_MENUS(state, { menus = state.siderMenus, current = state.currentMenu }) {
      state.siderMenus = menus
      state.currentMenu = current
    },
    setPowers(state, powers) {
      state.powers = _.get(powers, 'menus')
    },
    SET_IM_STATUS: (state, data) => {
      state.imStatus = data
    },
    // 设置IM配置
    SET_OCS_CONFIG(state, config = {}) {
      state.ocsConfigList = { ...state.ocsConfigList, ...config }
    },
    SET_IM_WORKBENCH_INFO(state, data) {
      state.imWorkBenchId = _.get(data, 'channelCode') || IM_WORKBENCH_MAP.ONLINE_IM
      state.recordTempId = _.get(data, 'recordTempId') // 小结单模板ID
      state.isBusinessIm = +state.imWorkBenchId === IM_WORKBENCH_MAP.ENTERPRISE_IM
      if (sessionStorage) {
        sessionStorage.setItem('imWorkBenchId', state.imWorkBenchId)
        sessionStorage.setItem('isBusinessIm', state.isBusinessIm)
      }
    },
    SET_CURRENT_MENU(state, payload) {
      state.currentMenu = payload
    },
    setJumpSwitchConfig(state, config) {
      state.jumpSwitchConfig = config || {}
    }
  },
  subscribe: {
    'route/$$change': 'app/$$onRouteChange'
  }
}

function findCurrentMenu(menus, route) {
  const { matched } = route
  let menu
  for (let i = matched.length - 1; i > -1; i--) {
    const reg = matched[i]
    travel(menus, m => {
      if (reg.test(m.path?.includes('#') ? m.path.split('#')[1] : m.path)) {
        menu = m
        return false
      }
    })
    if (menu) {
      break
    }
  }
  return menu
}

function travel(arr, cb) {
  if (Array.isArray(arr)) {
    for (let i = 0, len = arr.length; i < len; i++) {
      let result = cb(arr[i])
      if (result !== false) {
        result = travel(arr[i].children, cb)
      }
      if (result === false) {
        return false
      }
    }
  }
}
